<div class="asset-upload-container h-full" *ngIf="applicationData">
  <thehubz-asset-edit-stepper
    *ngIf="isReady"
    #stepper
    [class.has-left-area]="(stepperType === 'metaData' && currentStep.stepperGroupName !== 'productionDetails') || stepperType === 'usageRights'"
    [stepperModel]="stepperData"
    [applicationData]="applicationData"
    [tagsInfo]="tagsInfo"
    [domainsMatchingFlag]="domainsMatchingFlag"
    [stepperType]="stepperType"
    [relationData]="relationData"
    [cumulatedTags]="cumulatedTags"
    [selectedAssetIds]="selectedAssetIds"
    [selectedAssetRelations]="selectedAssetRelations"
    [existingAssetListFiles]="existingAssetListFiles"
    (updateTagObject)="updateTagObject($event)"
    (stepChange)="onStepChange($event)"
    (formSubmit)="onSubmit($event)"
  >
    <div *ngIf="(stepperType === 'metaData' && currentStep.stepperGroupName !== 'productionDetails') || stepperType === 'usageRights'" leftAreaSlot class="overflow-y-auto widget-bg-color">
      <div *ngIf="existingAssetListFiles && existingAssetListFiles.length; else noFilesAdded" class="asset-preivew" style="--asset-item-padding: 0.7rem; --asset-item-gap: 1rem">
        <header class="asset-preview-header widget-bg-color">
          <span class="header-column" i18n>Asset</span>
          <span class="header-column name-column" i18n>Name</span>
          <span class="header-column type-column" i18n>Type</span>
        </header>

        <ol class="asset-preview-list">
          <li *ngFor="let file of assetListFiles" class="asset-preview-item">
            <thehubz-asset-item-basic [item]="file" [editFlag]="true" class="elevated rounded"> </thehubz-asset-item-basic>
          </li>
        </ol>
      </div>

      <ng-template #noFilesAdded>
        <div class="flex w-full h-full justify-center items-center" i18n>No files selected</div>
      </ng-template>
    </div>
  </thehubz-asset-edit-stepper>
</div>
